import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0dbd7913&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=0dbd7913&prod&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=0dbd7913&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports